import request from './request';

export function getFooterV3() {
    return request.get('/api/manage/footer/footerV3').then(({ data = {} }) => {
        return data.data;
    });
}

export function getFooterV2() {
    return request.get('/api/manage/footer/footerV2').then(({ data = {} }) => {
        return data.data;
    });
}

export function getFooterDesign() {
    return request
        .get('/api/manage/footer/footerDesign')
        .then(({ data = {} }) => {
            return data.data;
        });
}
